export function update(state, payload) {
    if (!!state.logged_in && !payload.logged_in) {
        // logging out clears all old state
        return payload;
    }
    return { ...state, ...payload };
}

export function profiles(state, payload) {
    return { ...state, profiles: payload };
}



// WEBPACK FOOTER //
// ./app/reducers/user.js